<template>
    <div class="registry-wrapper">
        <div class="columns">
            <div
                class="search-bar column"
                :class="[
                    situacao == 4 && permissao.create && permissaoPropriedade.create
                        ? 'is-4'
                        : situacao == 4 && (permissao.create || permissaoPropriedade.create)
                        ? 'is-6'
                        : 'is-8',
                ]"
            >
                <search-bar :onSearch="debouncedOnSearch" />
            </div>

            <div
                class="column situacao-select"
                :class="[
                    situacao == 4 && permissao.create && permissaoPropriedade.create
                        ? 'is-2'
                        : situacao == 4 && (permissao.create || permissaoPropriedade.create)
                        ? 'is-3'
                        : 'is-4',
                ]"
            >
                <vss-select
                    ref="situacaoInput"
                    title="situacao"
                    :options="situacaoSelect"
                    :mlLabels="true"
                    @input="onSituacaoChanged"
                    v-model="situacaoSelected"
                    :height="40"
                    :clearable="true"
                />
            </div>

            <!-- BOTÃO DE VÍNCULO -->
            <div class="column is-3" v-if="situacao == 4 && permissao.create">
                <button class="save-btn botao-acao" type="button" @click="showModal = !showModal">
                    {{ $t('vincular-propriedade') }}
                </button>
            </div>
            <!-- Botao redireciona para cadastro de nova Propriedade -->
            <div class="column is-3" v-if="situacao == 4 && permissaoPropriedade.create">
                <button
                    class="save-btn botao-acao"
                    type="button"
                    @click="
                        $router.push({
                            name: 'agro-propriedade-new',
                            query: { tela: 'plano-safra-propriedade', id: $route.params.id },
                        })
                    "
                >
                    {{ $t('novo-propriedade') }}
                </button>
            </div>
        </div>
        <!-- LISTAGEM -->
        <div class="registry-wrapper">
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assPlanoSafraTalhaoList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{ 'excluir-field': f.key == 'excluir' }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row[f.key] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else-if="f.key == 'tamanho'">
                            {{ props.row.areatotal }}
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <span v-if="situacao == 4 && permissao.update && !cantEdit">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModal" @fecharModal="fecharModal">
                <div class="bg">
                    <PropriedadeModal
                        :uuidagro_planosafra="this.$route.params.id"
                        :idcliente="this.planosafra.idcliente"
                        :currentUnidadeMedidaAreaId="getUnidadeMedidaAreaId()"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import AssPlanoSafraTalhaoService from '@/services/agro/planosafra/AssPlanoSafraPropriedadeService';
// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import PropriedadeModal from '@/components/agro/planosafra/modal/PropriedadeModal.vue';
import PlanoSafraService from '@/services/agro/planosafra/PlanoSafraService';

export default {
    components: {
        ContainerLoader,
        PropriedadeModal,
    },
    props: {
        cantEdit: {
            type: Boolean,
            default: false,
        },
        situacao: {
            type: Number,
            default: 4,
        },
    },
    data() {
        return {
            service: new AssPlanoSafraTalhaoService(this.$http, this.$router),
            servicePlanoSafra: new PlanoSafraService(this.$http, this.$router),
            assPlanoSafraTalhaoList: [],
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            fields: [
                { key: 'codigo', width: null, sortable: false, sortFn: null },
                { key: 'propriedade', width: null, sortable: false, sortFn: null },
                { key: 'area', width: null, sortable: false, sortFn: null },
                { key: 'talhao', width: null, sortable: false, sortFn: null },
                { key: 'tamanho', width: null, sortable: false, sortFn: null },
                { key: 'situacao', width: 70, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            permissao: false,
            showModal: false,
            modalCadastro: false,
            planosafra: {},
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);
        this.permissaoPropriedade = this.hasPermissionAccess(
            'agro',
            'agro-cadastros',
            'agro-propriedade'
        );
        this.permissao = this.hasPermissionAccess('agro', 'agro-planosafra', 'agro-planosafra');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-planosafra' },
            });
        } else {
            this.carregarPlanoSafra();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-propriedade-talhao-' + numberId;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        carregarPlanoSafra() {
            this.servicePlanoSafra
                .findByUuid(this.$route.params.id)
                .then((value) => {
                    this.planosafra = value.content;
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally((_) => {
                    if (this.planosafra != null) this.carregarDados();
                });
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;

            let params = [
                // Adicionar filtro complementar
                this.isNull(this.queryFilter) ? '.*' : this.removeToSearch(this.queryFilter),
                // parâmetro adicional com o id do que deve ser usado no filtro
                this.planosafra != null && this.planosafra.uuid ? this.planosafra.uuid : null,
            ];
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assPlanoSafraTalhaoList = value;
                    this.isEmpty = this.assPlanoSafraTalhaoList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os acertos.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    uuid: m.uuid,
                    codigo: m.uuid,
                    idcliente: m.idcliente,
                    propriedade: m.propriedade.nome,
                    talhao: m.talhao.descricao,
                    area: m.area.descricao,
                    situacao: m.situacao,
                    areatotal: m.talhao.area,
                    unidademedidaarea: m.unidademedidaarea,
                    excluir: 'excluir',
                    origempda: m.origempda,
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.propriedade }
                );
            this.$root.confirm({
                message: message,
                onConfirm: (_) => this.updateSituacaoRegistro(),
                onCancel: (_) => this.removePrompt(),
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-reativar-associacao-propriedade'
                    : 'msg-erro-ao-desativar-associacao-propriedade';

            this.isLoading = true;

            this.service
                .updateSituacao(this.delete.uuid)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            this.delete.situacao == 0
                                ? 'msg-sucesso-ao-reativar-associacao-propriedade'
                                : 'msg-sucesso-ao-desativar-associacao-propriedade';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        getUnidadeMedidaAreaId() {
            return this.assPlanoSafraTalhaoList.length > 0
                ? this.assPlanoSafraTalhaoList[0].unidademedidaarea.idunidademedidaarea
                : 0;
        },
        fecharModal() {
            this.modalCadastro = false;
            this.modalManage = false;
            this.showModal = false;
            this.carregarDados();
        },
    },
};
</script>
<style lang="scss" scoped>
.situacao-select {
    div {
        height: 40px;
    }
}

.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .search-bar {
        padding-bottom: 0.4rem;
    }

    .situacao-select {
        width: 100%;
        padding-bottom: 0.8rem;
    }

    .botao-acao {
        margin-top: 0;
    }
}
</style>
